// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/beastSearch-" + chunkId + "." + {"1":"bd89c75e","2":"d0da44b6","3":"bc23885a","4":"0910e0b5"}[chunkId] + ".min.js";
};